import styled from "styled-components";

export const LayoutMain = styled.main`
  overflow-x: hidden;
`;
